import {colorShades, colourPalette} from "../../../utils/uiUtils";

export const getLargePaletteShadesOrdered = (startColorIndex) => {
    const palette = [];
    const shades = ['maxColor', 'midColor', 'minColor'];

    const suffledPalette = colourPalette.slice(startColorIndex).concat(colourPalette.slice(0, startColorIndex));

    Object.values(suffledPalette).forEach(color => {
        Object.values(shades).forEach(shade => {
            const computedColorShades = colorShades(color);
            palette.push(computedColorShades[shade]);
        });
    });
    return palette;
};

export const getLargePaletteColorsOrdered = (startColorIndex) => {
    const palette = [];
    const shades = ['maxColor', 'midColor', 'minColor'];

    const suffledPalette = colourPalette.slice(startColorIndex).concat(colourPalette.slice(0, startColorIndex));

    Object.values(shades).forEach(shade => {
        Object.values(suffledPalette).forEach(color => {
            const computedColorShades = colorShades(color);
            palette.push(computedColorShades[shade]);
        });
    });
    return palette;
};